// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GroupsSorts_wrapper__tTMTP","list":"GroupsSorts_list__3eDdG","button":"GroupsSorts_button__3HuRy","is_active":"GroupsSorts_is_active__6BWez"};